import { Document } from "@prismicio/client/types/documents";
import readTime from "lib/readTime";
import Image from "next/image";
import React from "react";

export default function Author({ article, author }: { article: Document; author: Document }) {
  return (
    <div className="flex flex-col sm:flex-row items-start sm:items-center">
      <div className="flex items-center">
        <div className="flex-shrink-0">
          <span className="sr-only">{author.data.name}</span>
          <div className="relative h-8 w-8 rounded-full">
            <Image
              src={author.data.photo.url}
              alt={author.data.name}
              layout="fill"
              objectFit="cover"
              className="rounded-full"
            />
          </div>
        </div>
        <div className="ml-3">
          <p className="text-sm font-medium text-gray-900">{author.data.name}</p>
        </div>
      </div>
      <div className="mt-2 sm:ml-3 sm:mt-0">
        <div className="flex space-x-1 text-sm text-gray-500">
          {article.first_publication_date && (
            <>
              <time dateTime={article.first_publication_date}>
                {new Intl.DateTimeFormat("en-US", {
                  year: "numeric",
                  month: "long",
                  day: "numeric",
                }).format(new Date(article.first_publication_date))}
              </time>
              <span aria-hidden="true">&middot;</span>
            </>
          )}
          <span>{readTime(article)} min read</span>
        </div>
      </div>
    </div>
  );
}
